module.exports = __webpack_public_path__ + "img/BDCIcon2.7b572f1e.png";